import { Component } from "solid-js";
import { parseCsv } from "../../utils/csv";

export interface CsvDropzoneProps {
  /** Called with the picked file and its parsed header row and data rows. */
  onFileParsed: (file: File, headers: string[], rows: string[][]) => void;
  class?: string;
}

export const CsvDropzone: Component<CsvDropzoneProps> = (props) => {
  const handleFileChange = (e: Event) => {
    const input = e.currentTarget as HTMLInputElement;
    const selected = input.files?.[0];
    if (!selected) return;

    const reader = new FileReader();
    reader.onload = (ev) => {
      const parsed = parseCsv(ev.target?.result as string);
      if (parsed.length === 0) return;
      props.onFileParsed(selected, parsed[0], parsed.slice(1));
    };
    reader.readAsText(selected);
  };

  return (
    <label
      class={`flex flex-col items-center justify-center w-full h-32 border-2 border-dashed border-line-strong rounded cursor-pointer hover:border-ink hover:bg-sunken transition-colors ${props.class ?? ""}`}
      aria-label="Upload CSV file"
    >
      <svg
        class="w-8 h-8 text-ink-3 mb-2"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"
        />
      </svg>
      <span class="text-sm text-ink-3">Click to upload a CSV file</span>
      <input
        type="file"
        accept=".csv,text/csv"
        class="sr-only"
        onChange={handleFileChange}
      />
    </label>
  );
};
